import React from 'react';
import { Link } from 'react-router-dom';

import CheckmarkIcon from '../../icons/CheckmarkIcon';

function ToolPicker() {
  return (
    <div className="tool-picker row">
      <div className="tool-picker__item">
        <h2 className="tool-picker__heading">
          Digital Tool
        </h2>
        <ul className="tool-picker__ul">
          <li className="tool-picker__li">
            <CheckmarkIcon />
            An assessment tracer tool that will help you identify areas of improvement for the safety of injectable medications in overall Patient Safety and Regulatory Compliance, Nursing, Pharmacy, and Anesthesia.
          </li>
          <li className="tool-picker__li">
            <CheckmarkIcon />
            Automated reminders
          </li>
          <li className="tool-picker__li">
            <CheckmarkIcon />
            Digital collaboration and contributor management
          </li>
          <li className="tool-picker__li">
            <CheckmarkIcon />
            Progress tracking and comparison tools
          </li>
        </ul>
        <Link to="/register" className="button button--large button--brand">
          Create an Account
        </Link>
      </div>
      <div className="tool-picker__item">
        <h2 className="tool-picker__heading">
          Print Tool
        </h2>
        <ul className="tool-picker__ul">
          <li className="tool-picker__li">
            <CheckmarkIcon />
            An assessment tracer tool that will help you identify areas of improvement for the safety of injectable medications in overall Patient Safety and Regulatory Compliance, Nursing, Pharmacy, and Anesthesia.
          </li>
          <li className="tool-picker__li tool-picker__li--disabled">
            <CheckmarkIcon />
            Automated reminders
          </li>
          <li className="tool-picker__li tool-picker__li--disabled">
            <CheckmarkIcon />
            Digital collaboration and contributor management
          </li>
          <li className="tool-picker__li tool-picker__li--disabled">
            <CheckmarkIcon />
            Progress tracking and comparison tools
          </li>
        </ul>
        <Link to="/download" className="button button--large button--brand">
          Download PDF
        </Link>
      </div>
    </div>
  );
}

export default ToolPicker;



// WEBPACK FOOTER //
// ./src/components/features/splash/ToolPicker.js